"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const url_1 = require("./url");
function isError(status) {
    return status < 200 || status >= 300;
}
exports.isError = isError;
/**Ejecuta una petición HTTP y devuelve la respuesta y el status en un objeto @see HttpRequestResult */
function httpRequest(request) {
    const urlParameters = request.urlParameters || {};
    const headers = request.headers || {};
    const body = request.body;
    const method = request.method;
    //Assign url parameters:
    //Aplanamos los key values que sean arreglos:
    const paramsStr = url_1.encodeUrlParameters(urlParameters);
    const url = paramsStr ? (request.url + "?" + paramsStr) : request.url;
    var req = new XMLHttpRequest();
    req.open(method, url, true);
    for (var key in headers) {
        const value = headers[key];
        if (value != null)
            req.setRequestHeader(key, "" + value);
    }
    req.send(body);
    return new Promise((resolve) => {
        req.onreadystatechange = ev => {
            if (req.readyState == 4) {
                resolve({
                    response: req.response,
                    status: req.status
                });
            }
        };
    });
}
exports.httpRequest = httpRequest;
//# sourceMappingURL=httpRequest.js.map


//////////////////
// WEBPACK FOOTER
// ./~/kea-resource/dist/http/httpRequest.js
// module id = 517
// module chunks = 0